import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingComponent } from '../modules/setting/setting.component';
import { DashComponent } from './pages/dash/dash.component';
import { AdminGuard } from '../models/guard/admin.guard';
import { EntryControlComponent } from '../modules/entry-control/entry-control.component';
import { AuthGuard } from '../models/guard/auth.guard';
import { ClientGuard } from '../models/guard/client.guard';
import { AdminStoreComponent } from '../modules/entry-control/store/admin-store/admin-store.component';
import { ProfileComponent } from '../modules/setting/users/profile/profile.component';
import { ListRecordsComponent } from '../modules/entry-control/records/list-records/list-records.component';
import { ListFacilitySupervisorComponent } from '../modules/entry-control/facility/list-facility-supervisor/list-facility-supervisor.component';
import { SuperGuard } from '../models/guard/super.guard';
import { ViewFacilityComponent } from '../modules/entry-control/facility/view-facility/view-facility.component';
import { EditStoreComponent } from '../modules/entry-control/store/edit-store/edit-store.component';
import { LogsComponent } from './pages/logs/logs.component';



const routes: Routes = [
  {
    path: '',
    component: ListRecordsComponent,
    canActivate:[AuthGuard],
    data: {
      title: 'Home',
      breadcrumb: [
        {
          label: 'INICIO',
          url: '',
        },
      ],
    },
  },
  {
    path: 'central-de-seguridad',
    canActivate: [AdminGuard],
    loadChildren: () =>
      import('./pages/security-center/security-center.module').then(
        (m) => m.SecurityCenterModule
      ),
    data: {
      title: 'CENTRAL DE SEGURIDAD',
      breadcrumb: [
        {
          label: 'Central de Seguridad',
          url: '/central-de-seguridad',
        },
      ],
    },
  },
  {
    path: 'supervision',
    canActivate: [AdminGuard],
    loadChildren: () => import('../modules/supervision/supervision.module').then((m) => m.SupervisionModule),
    data: {
      title: 'SUPERVISIÓN',
      breadcrumb: [{ label: 'Supervisión en terreno', url: '/supervision' }],
    },
  },
  //module setting
  {
    path: 'configuracion',
    component: SettingComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('../modules/setting/setting.module').then(
            (m1) => m1.SettingModule
          ),
      },
    ],
    data: {
      title: 'CONFIGURACIÓN',
      breadcrumb: [
        {
          label: 'General',
          url: '/configuracion',
        },
      ],
    },
  },
    //module entry
    {
      path: 'control-ingreso',
      component: EntryControlComponent,
      canActivate: [AdminGuard],
      children: [
        {
          path: '',
          loadChildren: () =>
            import('../modules/entry-control/entry-control.module').then(
              (m2) => m2.EntryControlModule
            ),
        },
      ],
      data: {
        title: 'CONTROL DE INGRESO',
        breadcrumb: [
          {
            label: 'Control de ingreso',
            url: '/control-ingreso',
          },
        ],
      },
    },
    {
      path: 'mi-recinto',
      canActivate: [ClientGuard],
      component: AdminStoreComponent,
      data: {
        title: 'MI RECINTO',
        breadcrumb: [
          {
            label: 'BIENVENIDO A SU RECINTO',
            url: '',
          },
        ],
      },
    },
    {
      path: 'supervisor',
      canActivate: [SuperGuard],
      component: ListFacilitySupervisorComponent,
      data: {
        title: 'SUPERVISOR',
        breadcrumb: [
          {
            label: 'SUPERVISOR - INSTALACIONES A CARGO',
            url: '',
          },
        ],
      },
    },
    {
      path: 'supervisar-instalacion/:id',
      canActivate: [SuperGuard],
      component: ViewFacilityComponent,
      data: {
        title: 'SUPERVISAR',
        breadcrumb: [
          {
            label: 'VISTA INSTALACIÓN SUPERVISOR',
            url: '',
          },
        ],
      },
    },
    {
      path: 'supervisar-dependencia/:id',
      canActivate: [SuperGuard],
      component: EditStoreComponent,
      data: {
        title: 'SUPERVISAR',
        breadcrumb: [
          {
            label: 'VISTA DEPENDENCIA SUPERVISOR',
            url: '',
          },
        ],
      },
    },
    {
      path: 'mi-perfil',
      component: ProfileComponent,
      data: {
        title: 'MI PERFIL',
        breadcrumb: [
          {
            label: 'Mi Perfil',
            url: '',
          },
        ],
      },
    },
    {
      path: 'logs',
      component: LogsComponent,
      data: {
        title: 'LOGS',
        breadcrumb: [
          {
            label: 'Log',
            url: '',
          },
        ],
      },
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrivateRoutingModule { }
